import type { AgGridReactProps } from 'ag-grid-react';

export interface SubMenuItem {
  iconClass: string;
  translationKey: string;
  action?: () => void;
  disabled?: boolean;
  tooltip?: string;
}

export interface ColumnAction<ActionKeyType> extends SubMenuItem {
  actionKey: ActionKeyType;
  subMenuItems?: SubMenuItem[];
}

export interface AgGridAsyncProps extends Omit<AgGridReactProps, 'modules'> {
  modules: AgGridModules[];
  isServerSideRowModel?: boolean;
}

export enum AgGridModules {
  ClipboardModule,
  CellSelectionModule,
  CellApiModule,
  SetFilterModule,
  ColumnMenuModule,
  ContextMenuModule,
  ColumnsToolPanelModule,
  MultiFilterModule,
  PinnedRowModule,
  RowAutoHeightModule,
  RowStyleModule,
  PaginationModule,
  RowDragModule,
  RowNumbersModule,
  RowSelectionModule,
  RowGroupingModule,
  RowApiModule,
  TextFilterModule,
  DateFilterModule,
  IntegratedChartsModule,
  TooltipModule,
  ServerSideRowModelApiModule,
  ColumnApiModule,
  QuickFilterModule,
  NumberFilterModule,
  CustomFilterModule,
  PivotModule,
  RowGroupingPanelModule,
  RenderApiModule,
  ClientSideRowModelApiModule,
  ColumnAutoSizeModule,
  CellStyleModule,
  CellSpanModule,
  EventApiModule,
  CustomEditorModule,
  TextEditorModule,
  LocaleModule,
  ScrollApiModule,
  GridStateModule,
  InfiniteRowModelModule,
  GroupFilterModule,
  ExcelExportModule,
  MasterDetailModule,
}
